import React from 'react';
import { legalDisclaimer } from '../data/mock';
import { doctorInfo } from '../data/mock';
import { 
  privacyPolicyFull, 
  healthDataConsent, 
  telemedicineConsentFull, 
  termsOfService 
} from '../data/legalDocuments';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';
import { ScrollArea } from './ui/scroll-area';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const LegalDocument = ({ title, content, lastUpdated }) => (
    <div className="space-y-4">
      <p className="text-xs text-[#64748b] mb-4">Last Updated: {lastUpdated}</p>
      <div className="whitespace-pre-line text-sm text-[#475569] leading-relaxed">
        {content}
      </div>
    </div>
  );

  return (
    <footer className="bg-[#0f172a] text-white">
      {/* Main Footer */}
      <div className="container py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-lg font-medium mb-2 text-white">
              Dr. Carlos Castellon, M.D.
            </h3>
            <p className="text-sm text-[#94a3b8] mb-4">
              General & Preventative Medicine
            </p>
            <p className="text-sm text-[#94a3b8]">
              {doctorInfo.location}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-[#94a3b8] font-medium mb-4">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#telemedicine" className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                  Telemedicine
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-[#94a3b8] font-medium mb-4">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/legal" className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                  View All Legal Documents
                </a>
              </li>
              <li>
                <Dialog>
                  <DialogTrigger asChild>
                    <button className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                      Privacy Policy
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-3xl max-h-[90vh] bg-white">
                    <DialogHeader>
                      <DialogTitle className="heading-2 text-[#0f172a]">
                        {privacyPolicyFull.title}
                      </DialogTitle>
                    </DialogHeader>
                    <ScrollArea className="h-[70vh] pr-4">
                      <LegalDocument {...privacyPolicyFull} />
                    </ScrollArea>
                  </DialogContent>
                </Dialog>
              </li>
              <li>
                <Dialog>
                  <DialogTrigger asChild>
                    <button className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                      Health Data Consent
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-3xl max-h-[90vh] bg-white">
                    <DialogHeader>
                      <DialogTitle className="heading-2 text-[#0f172a]">
                        {healthDataConsent.title}
                      </DialogTitle>
                    </DialogHeader>
                    <ScrollArea className="h-[70vh] pr-4">
                      <LegalDocument {...healthDataConsent} />
                    </ScrollArea>
                  </DialogContent>
                </Dialog>
              </li>
              <li>
                <Dialog>
                  <DialogTrigger asChild>
                    <button className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                      Telemedicine Consent
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-3xl max-h-[90vh] bg-white">
                    <DialogHeader>
                      <DialogTitle className="heading-2 text-[#0f172a]">
                        {telemedicineConsentFull.title}
                      </DialogTitle>
                    </DialogHeader>
                    <ScrollArea className="h-[70vh] pr-4">
                      <LegalDocument {...telemedicineConsentFull} />
                    </ScrollArea>
                  </DialogContent>
                </Dialog>
              </li>
              <li>
                <Dialog>
                  <DialogTrigger asChild>
                    <button className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                      Terms of Service
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-3xl max-h-[90vh] bg-white">
                    <DialogHeader>
                      <DialogTitle className="heading-2 text-[#0f172a]">
                        {termsOfService.title}
                      </DialogTitle>
                    </DialogHeader>
                    <ScrollArea className="h-[70vh] pr-4">
                      <LegalDocument {...termsOfService} />
                    </ScrollArea>
                  </DialogContent>
                </Dialog>
              </li>
              <li>
                <Dialog>
                  <DialogTrigger asChild>
                    <button className="text-sm text-[#94a3b8] hover:text-white transition-colors">
                      Medical Disclaimer
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-2xl bg-white">
                    <DialogHeader>
                      <DialogTitle className="heading-2 text-[#0f172a]">
                        {legalDisclaimer.title}
                      </DialogTitle>
                    </DialogHeader>
                    <ScrollArea className="max-h-[60vh] pr-4">
                      <div className="space-y-4">
                        {legalDisclaimer.content.split('\n\n').map((paragraph, index) => (
                          <p key={index} className="text-sm text-[#475569] leading-relaxed">
                            {paragraph}
                          </p>
                        ))}
                      </div>
                    </ScrollArea>
                  </DialogContent>
                </Dialog>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm uppercase tracking-wider text-[#94a3b8] font-medium mb-4">
              Contact
            </h4>
            <p className="text-sm text-[#94a3b8] mb-4">
              Get in touch today
            </p>
            <a
              href="#contact"
              className="inline-block bg-[#b8860b] text-white px-6 py-3 text-sm font-medium hover:bg-[#996f0a] transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1e293b]">
        <div className="container py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-[#64748b]">
              © {currentYear} Dr. Carlos Castellon, M.D. All rights reserved. Medical License No. 072870415
            </p>
            <p className="text-xs text-[#64748b] text-center md:text-right">
              Privacy maintained in accordance with GDPR and Spanish law. 
              For emergencies, call 112.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
